import type { ReactNode } from "react";
import { Box, Text, Tooltip } from "@hightouch/htui";

import {
  MEDIA_DETAIL_FIELD_GRID,
  MEDIA_DETAIL_FIELD_LABEL,
} from "src/components/media-detail/constants";

type Props = {
  label: string;
  /** Focusable so keyboard users can open the tooltip. */
  labelTooltip?: string | null;
  children: ReactNode;
};

/** A label/value row inside a `MediaDetailSection`. */
export function MediaDetailField({ label, labelTooltip, children }: Props) {
  const labelText = <Text {...MEDIA_DETAIL_FIELD_LABEL}>{label}</Text>;

  return (
    <Box
      {...MEDIA_DETAIL_FIELD_GRID}
      // Baseline, so the label lines up with a multi-line value's first line.
      alignItems="baseline"
    >
      <Box minW={0}>
        {labelTooltip ? (
          <Tooltip message={labelTooltip}>
            <Box
              as="span"
              tabIndex={0}
              borderRadius="sm"
              _focusVisible={{ boxShadow: "outline", outline: "none" }}
            >
              {labelText}
            </Box>
          </Tooltip>
        ) : (
          labelText
        )}
      </Box>
      <Box minW={0} fontSize="sm" wordBreak="break-word">
        {children}
      </Box>
    </Box>
  );
}
